/* ===== GENIUS MIND — interactions ===== */
(function () {
  'use strict';
  if (window.__r7gm_init) return; window.__r7gm_init = true;

  /* Scroll reveal */
  var revs = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    revs.forEach(function (r) { io.observe(r); });
  } else { revs.forEach(function (r) { r.classList.add('in'); }); }

  /* Nav shadow */
  var nav = document.getElementById('nav');
  window.addEventListener('scroll', function () {
    nav.classList.toggle('scrolled', window.scrollY > 12);
  }, { passive: true });

  /* Mobile menu */
  var burger = document.querySelector('.nav-burger');
  if (burger) burger.addEventListener('click', function () {
    var l = document.querySelector('.nav-links.left');
    if (!l) return;
    var open = l.style.display === 'flex';
    l.style.cssText = open ? '' : 'display:flex;position:absolute;top:66px;left:0;right:0;flex-direction:column;background:#fff;padding:16px 28px;border-bottom:1px solid var(--line);gap:14px';
  });

  /* Count-up */
  function count(el) {
    var t = parseFloat(el.getAttribute('data-count')), sfx = el.getAttribute('data-suffix') || '', dur = 1300, s = null;
    function step(ts) { if (!s) s = ts; var p = Math.min((ts - s) / dur, 1), e = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.floor(e * t).toLocaleString() + sfx;
      if (p < 1) requestAnimationFrame(step); else el.textContent = t.toLocaleString() + sfx; }
    requestAnimationFrame(step);
  }
  var cs = document.querySelectorAll('[data-count]');
  if ('IntersectionObserver' in window) {
    var cio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { count(e.target); cio.unobserve(e.target); } }); }, { threshold: 0.6 });
    cs.forEach(function (c) { cio.observe(c); });
  }

  /* Animate conversion bars (reason 4) when they scroll into view */
  var bars = document.querySelectorAll('.cv-side .bar i[data-w]');
  if (bars.length && 'IntersectionObserver' in window) {
    var bio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.style.width = e.target.getAttribute('data-w') + '%'; bio.unobserve(e.target); }
      });
    }, { threshold: 0.4 });
    bars.forEach(function (x) { bio.observe(x); });
  } else {
    bars.forEach(function (x) { x.style.width = x.getAttribute('data-w') + '%'; });
  }

  /* Generic carousel helper */
  function carousel(slidesSel, opts) {
    var slides = Array.prototype.slice.call(document.querySelectorAll(slidesSel));
    if (!slides.length) return;
    var i = 0, dots = opts.dots ? Array.prototype.slice.call(document.querySelectorAll(opts.dots)) : [],
        thumbs = opts.thumbs ? Array.prototype.slice.call(document.querySelectorAll(opts.thumbs)) : [];
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
    }
    var pv = opts.prev && document.querySelector(opts.prev); if (pv) pv.addEventListener('click', function () { go(i - 1); });
    var nx = opts.next && document.querySelector(opts.next); if (nx) nx.addEventListener('click', function () { go(i + 1); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-go'), 10)); }); });
    if (opts.auto) setInterval(function () { go(i + 1); }, opts.auto);
    return go;
  }

  /* Hero carousel (advisory / replaces / results slides) */
  carousel('.hero-slide', { prev: '.adv-arrow.prev', next: '.adv-arrow.next', dots: '.adv-dots i', auto: 4200 });

  /* Product gallery */
  carousel('.g-slide', { prev: '.g-arrow.prev', next: '.g-arrow.next', thumbs: '.g-thumb' });

  /* Buy-box tabs — animate height only during the switch, then release to auto
     so nested ingredient accordions can expand/collapse freely (no clipping, no stuck height) */
  var tabpanes = document.querySelector('.tabpanes');
  function animateTabHeight() {
    if (!tabpanes) return;
    var pane = tabpanes.querySelector('.tabpane.is-active');
    if (!pane) return;
    var start = tabpanes.offsetHeight;
    tabpanes.style.overflow = 'hidden';
    tabpanes.style.height = start + 'px';
    void tabpanes.offsetHeight;
    tabpanes.style.transition = 'height .35s cubic-bezier(.4,0,.2,1)';
    tabpanes.style.height = pane.scrollHeight + 'px';
    clearTimeout(tabpanes._th);
    tabpanes._th = setTimeout(function () {
      tabpanes.style.height = 'auto';
      tabpanes.style.overflow = 'visible';
      tabpanes.style.transition = '';
    }, 380);
  }
  var tabs = document.querySelectorAll('.tab');
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var n = tab.getAttribute('data-tab');
      tabs.forEach(function (t) { t.classList.remove('is-active'); }); tab.classList.add('is-active');
      document.querySelectorAll('.tabpane').forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-pane') === n); });
      animateTabHeight();
    });
  });

  /* Offer box — two collapsible blocks (Subscribe / One-Time); opening one collapses the other */
  var offerbox = document.querySelector('.offerbox');
  if (offerbox) {
    var blocks = offerbox.querySelectorAll('.ob-block');
    var BULLETS = {
      sub: ['Save 44% on first order, 37% off ongoing', 'Fast & Free shipping on all orders', 'No contract — pause, skip & cancel anytime'],
      ot: ['Fast & Free shipping on all orders', '90-day money-back guarantee', 'One-time payment — no auto-renewal']
    };
    function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;'); }
    blocks.forEach(function (block) {
      var mode = block.getAttribute('data-mode');
      var cards = block.querySelectorAll('.pcard');
      var elSave = block.querySelector('.ob-save'),
          elName = block.querySelector('.obd-name'),
          elPrice = block.querySelector('.obd-price'),
          elServ = block.querySelector('.obd-serv'),
          elList = block.querySelector('.obd-list');
      function render() {
        var card = block.querySelector('.pcard.is-selected') || cards[0];
        var p = card.getAttribute('data-price') || '',
            w = card.getAttribute('data-was') || '',
            serv = card.getAttribute('data-serv') || '',
            save = card.getAttribute('data-save') || '',
            freq = card.getAttribute('data-freq') || '';
        if (elSave) elSave.textContent = save;
        if (elName) elName.textContent = card.querySelector('.pc-name').textContent;
        if (elPrice) elPrice.innerHTML = (w ? '<s>' + esc(w) + '</s> ' : '') + '<b>' + esc(p) + '</b>';
        if (elServ) elServ.textContent = serv;
        if (elList) elList.innerHTML = [freq].concat(BULLETS[mode]).map(function (t) { return '<li><i class="ck"></i>' + esc(t) + '</li>'; }).join('');
      }
      cards.forEach(function (c) {
        c.addEventListener('click', function () {
          cards.forEach(function (x) { x.classList.remove('is-selected'); });
          c.classList.add('is-selected');
          render();
        });
      });
      var head = block.querySelector('.ob-mode');
      head.addEventListener('click', function () {
        blocks.forEach(function (b) { b.classList.remove('is-open'); });
        block.classList.add('is-open');
      });
      render();
    });
  }

  /* Animated accordions — single-open, height transition (one closes as another opens) */
  document.querySelectorAll('.acc-group').forEach(function (group) {
    group.querySelectorAll(':scope > .acc > .acc-head').forEach(function (head) {
      head.addEventListener('click', function () {
        var acc = head.parentElement;
        var body = acc.querySelector('.acc-body');
        var wasOpen = acc.classList.contains('open');
        group.querySelectorAll(':scope > .acc').forEach(function (a) {
          a.classList.remove('open');
          var bd = a.querySelector('.acc-body');
          if (bd) bd.style.maxHeight = '0px';
        });
        if (!wasOpen) {
          acc.classList.add('open');
          body.style.maxHeight = body.firstElementChild.scrollHeight + 24 + 'px';
        }
      });
    });
  });

  /* Slow CONTINUOUS auto-scroll for horizontal rails (videos, reviews, info bar).
     Resize-aware: duplicates content for a seamless loop the first time it overflows
     (so a bar that only overflows at mobile widths still starts scrolling). */
  document.querySelectorAll('.auto-scroll').forEach(function (el) {
    var dup = false, paused = false, resume, pos = 0;
    function ensureDup() {
      if (!dup && el.scrollWidth > el.clientWidth + 4) {
        Array.prototype.slice.call(el.children).forEach(function (k) { el.appendChild(k.cloneNode(true)); });
        dup = true;
      }
    }
    function pause() { paused = true; clearTimeout(resume); }
    function play() { clearTimeout(resume); resume = setTimeout(function () { pos = el.scrollLeft; paused = false; }, 1500); }
    el.addEventListener('mouseenter', pause); el.addEventListener('mouseleave', play);
    el.addEventListener('touchstart', pause, { passive: true }); el.addEventListener('touchend', play, { passive: true });
    window.addEventListener('resize', ensureDup);
    ensureDup();
    setTimeout(ensureDup, 400);   // re-check after web fonts settle
    setInterval(function () {
      if (paused || !dup) return;
      var half = el.scrollWidth / 2;
      if (half < 10) return;
      pos += 0.5;
      if (pos >= half) pos -= half;   // seamless loop (2nd half is identical)
      el.scrollLeft = pos;
    }, 16);
  });

  /* Reviews: "Show more" reveals the initially-collapsed rows */
  var moreBtn = document.querySelector('.jm-more-btn');
  var jmRows = document.querySelectorAll('.jm-row');
  var jmEmpty = document.querySelector('.jm-empty');
  var expanded = false;
  if (moreBtn) {
    moreBtn.addEventListener('click', function () {
      expanded = true;
      document.querySelectorAll('.jm-row.jm-hidden').forEach(function (c) { c.classList.remove('jm-hidden'); });
      moreBtn.style.display = 'none';
    });
  }

  /* Reviews: star-rating filter pills */
  var jmFilters = document.querySelectorAll('.jm-filters span');
  jmFilters.forEach(function (f) {
    f.addEventListener('click', function () {
      jmFilters.forEach(function (x) { x.classList.remove('on'); });
      f.classList.add('on');
      var val = f.getAttribute('data-filter');
      var shown = 0;
      jmRows.forEach(function (row, i) {
        var match = val === 'all' ? true : row.getAttribute('data-stars') === val;
        // in "all" view keep the collapsed-until-Show-more behaviour; filtered views show every match
        var visible = match && (val !== 'all' || expanded || i < 8);
        row.style.display = visible ? '' : 'none';
        if (match) shown++;
      });
      if (jmEmpty) jmEmpty.hidden = shown > 0;
      if (moreBtn) moreBtn.style.display = (val === 'all' && !expanded) ? '' : 'none';
    });
  });

  /* FAQ: smooth animated accordions (multi-open) */
  document.querySelectorAll('.faq-item .faq-q').forEach(function (q) {
    q.addEventListener('click', function () {
      var item = q.parentElement, a = item.querySelector('.faq-a');
      if (item.classList.contains('open')) {
        a.style.maxHeight = a.scrollHeight + 'px';
        requestAnimationFrame(function () { a.style.maxHeight = '0px'; });
        item.classList.remove('open');
      } else {
        item.classList.add('open');
        a.style.maxHeight = a.firstElementChild.scrollHeight + 'px';
      }
    });
  });

  /* Testimonial videos: show first frame, click to play with sound (pauses others), click to pause */
  document.querySelectorAll('.tcard.vid').forEach(function (card) {
    var v = card.querySelector('.tc-video');
    var pp = card.querySelector('.tc-pp');
    if (!v) return;
    // render a first frame so it isn't a blank box before playing
    v.addEventListener('loadedmetadata', function () { try { v.currentTime = 0.5; } catch (e) {} });
    function toggle() {
      if (v.paused) {
        document.querySelectorAll('.tcard.vid .tc-video').forEach(function (o) {
          if (o !== v) { o.pause(); }
        });
        v.muted = false;
        v.play().catch(function () {});
      } else { v.pause(); }
    }
    v.addEventListener('click', toggle);
    if (pp) pp.addEventListener('click', function (e) { e.stopPropagation(); toggle(); });
    v.addEventListener('play', function () { card.classList.add('playing'); });
    v.addEventListener('pause', function () { card.classList.remove('playing'); });
    v.addEventListener('ended', function () { card.classList.remove('playing'); });
  });

  /* Click-through offer: evergreen countdown to end of day */
  var cd = document.getElementById('cto-countdown');
  if (cd) {
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var tick = function () {
      var now = new Date();
      var end = new Date(now); end.setHours(24, 0, 0, 0);
      var diff = Math.max(0, end - now);
      var h = Math.floor(diff / 3600000), m = Math.floor(diff % 3600000 / 60000), s = Math.floor(diff % 60000 / 1000);
      cd.textContent = pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's';
    };
    tick(); setInterval(tick, 1000);
  }

  /* Sticky bar: appears only after scrolling past the hero; tucks away over buy box / footer */
  var bar = document.getElementById('stickybar');
  var hero = document.querySelector('.hero');
  var buy = document.getElementById('buy');
  var foot = document.querySelector('.site-footer');
  if (bar && 'IntersectionObserver' in window) {
    var vis = {};
    var sio = new IntersectionObserver(function (es) {
      es.forEach(function (e) { vis[e.target.getAttribute('data-sb')] = e.isIntersecting; });
      var hide = vis.hero || vis.buy || vis.foot;
      bar.style.transform = hide ? 'translateY(100%)' : 'translateY(0)';
    }, { threshold: 0.04 });
    if (hero) { hero.setAttribute('data-sb', 'hero'); sio.observe(hero); }
    if (buy) { buy.setAttribute('data-sb', 'buy'); sio.observe(buy); }
    if (foot) { foot.setAttribute('data-sb', 'foot'); sio.observe(foot); }
  }
})();
